<template>
  <div id="vessel-edit">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="船舶情報">
            <div class="tab-text">
              <tab-vessel-general-info class="mt-4" />
            </div>
          </vs-tab>

          <vs-tab label="写真">
            <div class="tab-text">
              <tab-vessel-gallery class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import TabVesselGeneralInfo from "./tabs/tabVesselGeneralInfo";
import TabVesselGallery from "./tabs/tabVesselGallery";

const { mapActions } = createNamespacedHelpers("enterpriseVesselEdit");

export default {
  components: {
    TabVesselGeneralInfo,
    TabVesselGallery
  },
  data() {
    return {
      activeTab: 0
    };
  },
  watch: {
    // activeTab() {
    //   this.fetch_user_data(this.$route.params.id)
    // }
  },
  methods: {
    ...mapActions(["fetchVessel", "fetchGallery"]),
  }
};
</script>
